import React from 'react';
import {
  ActionIcon,
  Button,
  Group,
  Text,
  Tooltip
} from '@mantine/core';
import { IconCloudUpload, IconFileDownload, IconFileTypeXls, IconFilter, IconFilterFilled, IconPlus, IconRefresh } from '@tabler/icons-react';
import Tabla from '../../../globales/componentes/tabla/tabla';
import FiltroTareasVista from './filtroTareasVista';
import { crearEstadoInicialTarea, type ITablaTareasVistaProps } from '../interfaces';

const TablaTareasVista: React.FunctionComponent<ITablaTareasVistaProps> = ({
  tabla,
  abrirModalTarea,
  consultarTareas,
  filtro,
  manejarCambioFiltroTarea,
  habilitarFiltros,
  manejarHabilitarFiltros,
  entidadesRegistro,
  limpiarFiltros,
  descargarPlantilla,
  cargaMasivaTareas,
  abrirModalExportacionExcel
}) => {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflowX: 'hidden' }}>
      <Group justify="space-between" mb="md">
        <Text fw={700} size="lg">Tareas</Text>
        <Group>
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={consultarTareas}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip>
            <Tooltip zIndex={100000} label="Exportar a Excel" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => abrirModalExportacionExcel(true)}
              >
                <IconFileTypeXls size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip zIndex={100000} label="Descargar Plantilla" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={descargarPlantilla}
              >
                <IconFileDownload size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip zIndex={100000} label="Carga Masiva (Preventivos)" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={cargaMasivaTareas}
              >
                <IconCloudUpload size={16} />
              </ActionIcon>
            </Tooltip>
          </Group>

          <Button
            color="primary"
            variant="light"
            size='xs'
            leftSection={<IconPlus color="var(--mantine-color-primary-0)" size={12} />}
            radius="lg"
            onClick={() => abrirModalTarea(true, crearEstadoInicialTarea())}
          >
            <Text fw={500} size="xs">Agregar Tarea</Text>
          </Button>
        </Group>
      </Group>
      {habilitarFiltros && (
        <FiltroTareasVista
          consultarTareas={consultarTareas}
          filtro={filtro}
          manejarCambioFiltroTarea={manejarCambioFiltroTarea}
          entidadesRegistro={entidadesRegistro}
          limpiarFiltros={limpiarFiltros}
          estadoModalExportacionExcel={false}
        />
      )}
      <div style={{ flex: 1, minHeight: 0 }}>
        <Tabla tabla={tabla} />
      </div>
    </div>
  );
};

export default React.memo(TablaTareasVista);
